module.exports = __webpack_public_path__ + "img/系统监控select.85b5110d.svg";